import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LogIn, Lock } from "lucide-react";
import { Button } from "../../components/ui/button";

export default function LoginRequired({ title = "Sign in to continue", description = "Login with your phone number to access this section." }) {
  const loc = useLocation();
  const ret = encodeURIComponent(loc.pathname);
  return (
    <div className="px-5 min-h-[70vh] flex items-center page-enter" data-testid="login-required-card">
      <div className="bg-white rounded-3xl border border-neutral-200 p-8 text-center max-w-md mx-auto w-full">
        <div className="w-16 h-16 rounded-3xl bg-brand-sky/10 text-brand-sky flex items-center justify-center mx-auto">
          <Lock className="w-8 h-8" strokeWidth={2.2} />
        </div>
        <h2 className="font-heading text-2xl font-extrabold mt-5">{title}</h2>
        <p className="text-neutral-600 mt-2 leading-relaxed">{description}</p>
        <Link to={`/login?return=${ret}`}>
          <Button className="mt-6 h-14 rounded-2xl bg-brand-sky hover:bg-blue-700 font-bold px-7 w-full" data-testid="sign-in-cta">
            <LogIn className="w-4 h-4 mr-2" /> Sign in with phone
          </Button>
        </Link>
        <p className="text-xs text-neutral-500 mt-4">New here? You'll be auto-registered.</p>
      </div>
    </div>
  );
}
